import { prisma, MergeTagGroup } from "client";

// CREATE
export const createMergeTagGroup = async (mergeTagGroup: MergeTagGroup) => {
  try {
    const newMergeTagGroup = await prisma.mergeTagGroup.create({
      data: mergeTagGroup,
    });
    return { mergeTagGroup: newMergeTagGroup };
  } catch (error) {
    return { error };
  }
};

export const createManyMergeTagGroups = async (
  mergeTagGroups: MergeTagGroup[]
) => {
  try {
    const newMergeTagGroups = await prisma.mergeTagGroup.createMany({
      data: mergeTagGroups,
    });
    return { mergeTagGroups: newMergeTagGroups };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllMergeTagGroups = async () => {
  try {
    const mergeTagGroups = await prisma.mergeTagGroup.findMany();
    return mergeTagGroups;
  } catch (error) {
    return { error };
  }
};

export const getMergeTagGroupById = async (id: string) => {
  try {
    const mergeTagGroup = await prisma.mergeTagGroup.findUnique({
      where: { id },
    });
    return { mergeTagGroup };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateMergeTagGroup = async (
  id: string,
  mergeTagGroup: MergeTagGroup
) => {
  try {
    const updatedMergeTagGroup = await prisma.mergeTagGroup.update({
      where: { id },
      data: mergeTagGroup,
    });
    return { mergeTagGroup: updatedMergeTagGroup };
  } catch (error) {
    return { error };
  }
};

// DELETE
export const deleteMergeTagGroup = async (id: string) => {
  try {
    const deletedMergeTagGroup = await prisma.mergeTagGroup.delete({
      where: { id },
    });
    return { mergeTagGroup: deletedMergeTagGroup };
  } catch (error) {
    return { error };
  }
};
